import React, {useState, useEffect, useRef} from 'react'
import { Link} from 'react-router-dom'
import { Toaster } from 'react-hot-toast';
import axios from 'axios';
import AdminTitle from '../AdminTitle'
import Select from 'react-select'
import { customSelectStylesForJobIndex } from '../utils/selectStyles'
import { Industry, SelectOptionType } from '../../types/jobTypes'
import { useCityOptions } from '../utils/usePrefectureAndCityOptions'
// areaについては戻せるように一旦コメントアウト化、様子を見て使用しなさそうなら削除
type Job = {
  id: number;
  company_name: string;
  industry: string;
  prefecture: string;
  city: string;
  // area: string;
  phone_number: string;
  closing_date: string;
}[] | null;

export default function JobIndex() {
  // APIから取得した情報の状態管理
  const [jobs, setJobs] = useState<Job>(null)
  const [industries, setIndustries] = useState<Industry[]>([])
  // const [prefectures, setPrefectures] = useState<Prefecture[]>([])
  // const [areas, setAreas] = useState<Area[]>([])
  // リロードさせるかどうかの状態管理
  const [needReload, setNeedReload] = useState(false)
  // ページネーション表示用の状態管理
  const [nowPage, setNowPage] = useState<number>(1)
  const [allPage, setAllPage] = useState<number>(1)
  const [pageList, setPageList] = useState<number[]>([])
  // 検索フォームの状態管理
  const [searchName, setSearchName] = useState<string | null>(null)
  const [searchIndustryId, setSearchIndustryId] = useState<string | null>(null)
  const [searchPrefectureId, setSearchPrefectureId] = useState<string | null>(null)
  const [searchCityId, setSearchCityId] = useState<string | null>(null)
  // const [searchAreaId, setSearchAreaId] = useState<string | null>(null)
  // 検索フォームの入力を更新する
  const searchNameRef = useRef<HTMLInputElement | null>(null);
  const searchIndustryIdRef = useRef<HTMLSelectElement | null>(null);
  // const searchAreaIdRef = useRef<HTMLSelectElement | null>(null);

  // 以下、react-select関連の定義
  const {
    cityOption,
    cityOptions,
    loadingCities,
    defaultCityOption,
    defaultPrefectureOption,
    prefectureOption,
    prefectureOptions,
    setCityOption,
    setCityOptions,
    updateCityOptions,
    setPrefectureOption,
    initializePrefectureOptions,
  } = useCityOptions()

  // リロード処理時にAPIから求人一覧を取得して表示
  useEffect(() => {
    axios.get('/api/v1/industries').then (res => setIndustries(JSON.parse(res.data.industries)));
    axios.get('/api/v1/prefectures').then (res => initializePrefectureOptions(JSON.parse(res.data.prefectures)));
    // axios.get('/api/v1/areas').then (res => setAreas(JSON.parse(res.data.areas)));
    axios.get('/api/v1/jobs')
    .then(res => {
      setJobs(JSON.parse(res.data.data))
      if (searchNameRef.current) {searchNameRef.current.value = ''}
      if (searchIndustryIdRef.current) {searchIndustryIdRef.current.value = ''};
      // if (searchAreaIdRef.current) {searchAreaIdRef.current.value = ''};
      setSearchName(null);
      setSearchIndustryId(null);
      setSearchPrefectureId(null);
      setSearchCityId(null);
      setPrefectureOption(defaultPrefectureOption)
      setCityOptions([defaultCityOption])
      setCityOption(defaultCityOption)
      // setSearchAreaId(null);
      const page : number = Math.ceil(res.data.count / 10)
      setAllPage(page)
      const pageArray : number[] = []
      for (let i = 1; i <= page; i++) {
        pageArray.push(i)
      }
      setPageList(pageArray)
    })
    .catch(error => {
      console.log(error)
    });
  }, [needReload]);

  // 検索した際の求人一覧の取得
  const fetchJobs = () => {
    axios.get('/api/v1/jobs/search', { params: { keyword: searchName, industry_id: searchIndustryId, prefecture_id: searchPrefectureId, city_id: searchCityId } })
    .then(res => {
      setJobs(JSON.parse(res.data.data));
      const page : number = Math.ceil(res.data.count / 10);
      setAllPage(page);
      setNowPage(1);
      const pageArray : number[] = []
      for (let i = 1; i <= page; i++) {
        pageArray.push(i)
      }
      setPageList(pageArray)
    })
    .catch(error => {
      console.log(error);
      alert('何らかのエラーが発生しました。もう一度お試しください。')
    });
  };

  return (
    <>
      <AdminTitle title={'求人一覧'} />
      <Toaster />
      <div className='admin-bg__color'>
        <div className='breadcrumb'><ul><li>求人一覧</li></ul></div>
        <div className='admin-list__card'>
          <div className='admin-list__card__header'>
            <div className='admin-list__card__header--form'>
              <input ref={searchNameRef} className='admin-list__card__header--form-main' placeholder='企業名を入力' onChange={(e) => setSearchName(e.target.value)} />
              <select ref={searchIndustryIdRef} className='admin-list__card__header--form-main select' onChange={(e) => setSearchIndustryId(e.target.value === '' ? null : e.target.value)} >
                <option value=''>業種を選択</option>
                { industries.map( industry =>
                  <option value={industry.id}>{industry.name}</option>
                )}
              </select>

              <div style={ {marginLeft: '5px'} }>
                <Select<SelectOptionType>
                  options={prefectureOptions}
                  value={prefectureOption}
                  defaultValue={defaultPrefectureOption}
                  styles={customSelectStylesForJobIndex}
                  onChange={ selectedOption => {
                    if(selectedOption && selectedOption.value) {
                      setPrefectureOption({"value": selectedOption.value, "label": selectedOption.label})
                      setSearchPrefectureId(String(selectedOption.value))
                      updateCityOptions(selectedOption.value)
                      setSearchCityId(null)
                    } else {
                      setSearchPrefectureId(null)
                      setCityOptions([defaultCityOption])
                      setSearchCityId(null)
                    }
                  }}
                />
              </div>
              <div style={ {marginLeft: '10px'} }>
                <Select<SelectOptionType>
                  options={cityOptions}
                  value={cityOption}
                  defaultValue={defaultCityOption}
                  styles={customSelectStylesForJobIndex}
                  isLoading={loadingCities}
                  onChange={ selectedOption => {
                    if(selectedOption) {
                      setCityOption({"value": selectedOption.value, "label": selectedOption.label})
                      setSearchCityId(String(selectedOption.value))
                    } else {
                      setCityOptions([defaultCityOption])
                      setSearchCityId(null)
                    }
                  }}
                />
              </div>
              {/* <select ref={searchAreaIdRef} className='admin-list__card__header--form-main select' onChange={(e) => setSearchAreaId(e.target.value === '' ? null : e.target.value)} >
                <option value=''>地域を選択</option>
                { areas.map( area =>
                  <option value={area.id}>{`${area.name} / ${area.prefecture}`}</option>
                )}
              </select> */}

            </div>
            <div className='admin-list__card__header--btn'>
              <div className='admin-list__card__header--btn-search' onClick={() => fetchJobs()}>
                <i className="material-icons">search</i>
                <div>検索</div>
              </div>
              <div className='admin-list__card__header--btn-reset' onClick={() => setNeedReload(!needReload)}>
                <div>リセット</div>
              </div>
            </div>
          </div>

          <div className='admin-list__card__body border-top'>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th className='head-text ps-4'>企業名</th>
                  <th className='head-text'>業種</th>
                  <th className='head-text'>都道府県</th>
                  <th className='head-text'>市区町村</th>
                  <th className='head-text'>電話番号</th>
                  <th className='head-text'>掲載最終日</th>
                  <th className='head-text'></th>
                </tr>
              </thead>

              <tbody>
              {
                jobs &&
                jobs.slice((nowPage - 1) * 10, nowPage * 10).map(job =>
                  <tr key={job.id}>
                    <td className='py-4 content-text ps-4'>
                      <Link to={`/admins/jobs/${job.id}`}>
                        {job.company_name}
                      </Link>
                    </td>
                    <td className='py-4 content-text'>{job.industry}</td>
                    {/* <td className='py-4 content-text'>{job.area}</td> */}
                    <td className='py-4 content-text'>{job.prefecture}</td>
                    <td className='py-4 content-text'>{job.city}</td>
                    <td className='py-4 content-text'>{job.phone_number}</td>
                    <td className='py-4 content-text'>{job.closing_date}</td>
                    <td className='py-2 align-middle text-end'>
                      <div className="d-flex justify-content-end pe-4">
                        <Link to={`/admins/jobs/edit/${job.id}`} className='btn btn-edit'>
                          <span className='material-symbols-outlined'>edit</span>
                          編　集
                        </Link>
                      </div>
                    </td>
                  </tr>
                )
              }
              </tbody>
            </table>
          </div>

          {/* ページネーション */}
          <div className='admin-list__card__footer'>
            <div className='d-flex align-items-center justify-content-center'>
              {nowPage > 1 && (
                <span className='material-symbols-outlined arrow-back arrow-back__active me-2 p-2' onClick={() => setNowPage(nowPage - 1)}>
                  arrow_back
                </span>
              )}
              {nowPage == 1 && (
                <span className='material-symbols-outlined arrow-back arrow-back__inactive me-2 p-2'>
                  arrow_back
                </span>
              )}
              {nowPage > 3 && (
                <button key={1} className='btn btn-pagenation mx-1' onClick={() => setNowPage(1)} >{1}</button>
              )}
              {nowPage > 4 && (
                <button key={2} className='btn btn-pagenation mx-1' onClick={() => setNowPage(2)} >{2}</button>
              )}
              {nowPage > 5 && (
                <button key={3} className='btn btn-pagenation mx-1' onClick={() => setNowPage(3)} >{3}</button>
              )}
              {nowPage > 5 && (
                <span className='mx-2'>...</span>
              )}
              {pageList
                .filter(page => page >= Math.max(1, nowPage - 2) && page <= Math.min(allPage, nowPage + 2))
                .map(page => (
                  <button
                    key={page}
                    className={`btn btn-pagenation mx-1 ${page === nowPage ? 'active' : ''}`}
                    onClick={() => setNowPage(page)}
                  >
                    {page}
                  </button>
                ))
              }
              {allPage - nowPage > 5 && (
                <span className='mx-2'>...</span>
              )}
              {allPage - nowPage > 4 && (
                <button key={allPage - 2} className='btn btn-pagenation mx-1' onClick={() => setNowPage(allPage - 2)} >{allPage - 2}</button>
              )}
              {allPage - nowPage > 3 && (
                <button key={allPage - 1} className='btn btn-pagenation mx-1' onClick={() => setNowPage(allPage - 1)} >{allPage - 1}</button>
              )}
              {allPage - nowPage > 2 && (
                <button key={allPage } className='btn btn-pagenation mx-1' onClick={() => setNowPage(allPage )} >{allPage }</button>
              )}
              {nowPage < allPage && (
                <span className='material-symbols-outlined arrow-next arrow-next__active' onClick={() => setNowPage(nowPage + 1)}>
                  arrow_forward
                </span>
              )}
              {nowPage == allPage && (
                <span className='material-symbols-outlined arrow-next arrow-next__inactive'>
                  arrow_forward
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
